
const cache = {
  state: {
    cacheNewLoanInformation: undefined,
  },
};

export default cache;
